<template>
  <div id="about">
    <h2>About</h2>
    <p>Created for the TELL project by <a href="https://aris-space.ch/">Akademische Raumfahrt Initiative Schweiz (ARIS)</a></p>
    <p>Visualization and supporting infrastructure designed and programmed by <a href="https://pascalsommer.ch">Pascal Sommer</a>.</p>
  </div>
</template>

<script>

export default {
  name: 'About',
  data () {
    return {
    };
  },
}
</script>

<style scoped>
a{
  color: #868686;
  text-decoration-style: dotted;
}

a:visited{
  color: #868686;
}

a:hover{
  color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue